import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import namespaces from '@utils/namespaces';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: ['pt', 'en', 'es'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_VERSION}`,
    },
    ns: namespaces,
  });

export const getAvailableLocales = () =>
  Object.keys(i18n.services.resourceStore.data);

export default i18n;
